import { paramParsers } from './param-parsers';
export class UrlParamsHandler {
    constructor(parsers) {
        Object.defineProperty(this, "parsers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: parsers
        });
    }
    static from(parsers) {
        return new UrlParamsHandler(parsers);
    }
    toString(values) {
        const params = {};
        if (!values) {
            return params;
        }
        for (const key of Object.keys(values)) {
            const parser = this.parsers[key];
            if (!parser) {
                continue;
            }
            const value = values[key];
            if (value !== undefined) {
                params[key] = parser.stringify(value);
            }
        }
        return params;
    }
    parse(params) {
        var _a;
        const values = {};
        for (const key of Object.keys(params)) {
            const parser = (_a = this.parsers) === null || _a === void 0 ? void 0 : _a[key];
            if (!parser) {
                continue;
            }
            const value = params[key];
            if (value !== undefined) {
                values[key] = parser.parse(value);
            }
        }
        return values;
    }
}
Object.defineProperty(UrlParamsHandler, "parserString", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: paramParsers.uri
});
Object.defineProperty(UrlParamsHandler, "parserNumber", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: paramParsers.number
});
//# sourceMappingURL=url-params-handler.js.map